import type { LoaderParams } from "~/components/abstracts/Image/loader"

export const HOSTNAME = "cdn.shopify.com"

export default function imageLoader({ src, width }: LoaderParams) {
  const connection = src.indexOf("?") === -1 ? "?" : "&"
  return `${src}${connection}width=${width}`
}
